// eslint-disable-next-line import/no-anonymous-default-export
export default {
    'HUET_CARD': {
        hasKey: false,
        hasExpiration: true,
        label: 'HUET Card',
        hasGenerateKey: false
    },
    'EBS_CARD': {
        hasKey: false,
        hasExpiration: true,
        label: 'EBS Card',
        hasGenerateKey: false
    },
    'ISN': {
        hasKey: true,
        hasExpiration: false,
        label: 'ISN',
        hasGenerateKey: false
    },
    'PASSPORT': {
        hasKey: true,
        hasExpiration: true,
        label: 'Passport',
        hasGenerateKey: false
    },
    'PASSPORT_CARD': {
        hasKey: true,
        hasExpiration: true,
        label: 'Passport Card',
        hasGenerateKey: false
    },
    'SAFETY_CARD': {
        hasKey: false,
        hasExpiration: true,
        label: 'Safety Card',
        needsButton: true,
        hasGenerateKey: false
    },
    'TWIC': {
        hasKey: true,
        hasExpiration: true ,
        label: 'TWIC Card',
        hasGenerateKey: false
    },
    'US_DRIVERS_LICENSE': {
        hasKey: true,
        hasExpiration: true,
        label: 'U.S. Driver\'s License',
        hasGenerateKey: false
    },
}